/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

export default getHolder;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_getHolder.js
// module id = 231
// module chunks = 67